import { useAppSelector } from "../../Redux/store";
import { DirectionButton } from "./DirectionButton"
import { ButtonActionResolver } from "../Resolvers/ButtonActionResolver";

export const DirectionalButtons = () => {
    const screen = useAppSelector(state => state.screenInteractions.screen)

    return (
        <div className="relative h-13 w-13 left-10 bg-black">
            <div className="absolute h-13 w-13 left-0 z-30 bg-black"/>
            <ButtonActionResolver button="up" screen={screen}>
                <DirectionButton direction="up"/>
            </ButtonActionResolver>
            <ButtonActionResolver button="right" screen={screen}>
                <DirectionButton direction="right"/>
            </ButtonActionResolver>
            <ButtonActionResolver button="down" screen={screen}>
                <DirectionButton direction="down"/>
            </ButtonActionResolver>
            <ButtonActionResolver button="left" screen={screen}>
                <DirectionButton direction="left"/>
            </ButtonActionResolver>
        </div>
    )
}